<script>
import PageHeader from '../../SettingsSubPageHeader.vue';
import WhatsappEmbeddedSignup from './WhatsappEmbeddedSignup.vue';

export default {
  components: {
    PageHeader,
    WhatsappEmbeddedSignup,
  },
};
</script>

<template>
  <div
    class="border border-slate-25 dark:border-slate-800/60 bg-white dark:bg-slate-900 h-full p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] flex-shrink-0 flex-grow-0"
  >
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.WHATSAPP.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.WHATSAPP.DESC')"
    />
    <div class="px-6 py-5 rounded-2xl border border-slate-100 dark:border-slate-700">
      <WhatsappEmbeddedSignup />
    </div>
  </div>
</template>
